import type { BlockScorm } from 'shared-types';

type LocaleData = BlockScorm['locales'][string];

const defaultBlockData = {
  format: 'html' as const,
  isMandatory: false,
  isTask: true,
  pointsWeight: 10,
  requireAnswerToProceed: false
};

const translatable: LocaleData['translatable'] = {
  openFullScreenMessage: ''
};
const defaultLocaleData: LocaleData = {
  aspectRatio: null,
  editorIframeSetZoomWidth: null,
  enableFullScreen: 'disabled' as const,
  file: null,
  minHeight: 600,
  scale: null,
  scormContents: null,
  scormManifest: null,
  scormObjectList: null,
  selectZoom: null,
  translatable,
  url: null,
  useAspectRatio: null
};

const localePlaceholders = {
  aspectRatio: '{{ locales.aspectRatio }}' as const,
  editorIframeSetZoomWidth: '{{ locales.editorIframeSetZoomWidth }}' as const,
  enableFullScreen: '{{ locales.enableFullScreen }}' as const,
  file: '{{ locales.file }}' as const,
  minHeight: '{{ locales.minHeight }}' as const,
  openFullScreenMessage:
    '{{ locales.translatable.openFullScreenMessage }}' as const,
  scale: '{{ locales.scale }}' as const,
  scormContents: '{{ locales.scormContents }}' as const,
  scormManifest: '{{ locales.scormManifest }}' as const,
  scormObjectList: '{{ locales.scormObjectList }}' as const,
  selectZoom: '{{ locales.selectZoom }}' as const,
  url: '{{ locales.url }}' as const,
  useAspectRatio: '{{ locales.useAspectRatio }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockScormData: BlockScorm = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockScorm['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
